import { render, staticRenderFns } from "./channelSdkConfigDeatils.vue?vue&type=template&id=3f05d280&scoped=true"
import script from "./channelSdkConfigDeatils.vue?vue&type=script&lang=js"
export * from "./channelSdkConfigDeatils.vue?vue&type=script&lang=js"
import style0 from "./channelSdkConfigDeatils.vue?vue&type=style&index=0&id=3f05d280&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05d280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f05d280')) {
      api.createRecord('3f05d280', component.options)
    } else {
      api.reload('3f05d280', component.options)
    }
    module.hot.accept("./channelSdkConfigDeatils.vue?vue&type=template&id=3f05d280&scoped=true", function () {
      api.rerender('3f05d280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/channelSdkConfig/channelSdkConfigDeatils.vue"
export default component.exports